import React from 'react';

export const ResizeHandleIcon = ({
  width = 24,
  height = 24,
  color = '#09C4FF',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 9 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="4.5" cy="4.5" r="4" fill="white" stroke={color} />
  </svg>
);
